import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'apcam-side-nav-link',
    templateUrl: './side-nav-link.component.html',
    styleUrls: ['./side-nav-link.component.scss'],
    imports: [MatListModule, MatIconModule, RouterLink, RouterLinkActive],
})
export class SideNavLinkComponent implements OnInit {
    /**
     * Icon name to display.
     *
     * @usageNotes
     * The `iconName` property is used to specify the icon to be displayed in the component.
     * It accepts a string representing the icon name or path.
     * If empty, the icon is not rendered at all
     *
     * @default ''
     */
    @Input()
    iconName: string = '';

    /**
     * Text for the navigation link.
     *
     * @usageNotes
     * The `navLinkText` property is used to set the text content for the navigation link in the component.
     * It accepts a string representing the text to be displayed.
     *
     * @default ''
     */
    @Input()
    navLinkText: string = '';

    /**
     * Base padding value in pixels.
     *
     * @usageNotes
     * The `paddingBase` property is used to set the base padding value (in pixels) for the component.
     * It is an optional input, and its default value is 16 pixels.
     *
     * @default 16px
     */
    @Input()
    paddingBase: number = 16; // [px]

    /**
     * Padding level for the navigation link.
     *
     * @usageNotes
     * The `paddingLevel` property is used to specify the padding level for the component.
     * It is an optional input, and its default value is 0.
     *
     * @default 0
     */
    @Input()
    paddingLevel: number = 0; // [1]

    /**
     * Router link for navigation.
     *
     * @usageNotes
     * The `routerLink` property is used to specify the router link for navigation in the component.
     * It is a required input, and its default value is an empty string.
     *
     * @required
     * @default ''
     */
    @Input({ required: true })
    routerLink: string = '';

    /**
     * Base left padding from angular material for list item.
     */
    PADDING_LEFT_BASE = 16; // [px]

    /**
     * Total left padding for navigation link.
     */
    paddingLeftTotal: number = this.PADDING_LEFT_BASE;

    ngOnInit(): void {
        this.paddingLeftTotal =
            this.PADDING_LEFT_BASE + this.paddingLevel * this.paddingBase;
    }
}
